/**
 * Fetches all pages from a paginated API endpoint.
 * The backend caps pages at 20 items even when `all=true` is passed,
 * so this helper fetches page 1, reads `last_page`, then fetches
 * remaining pages in parallel.
 */
export async function fetchAllPages<T>(
    fetchFn: (page: number) => Promise<{ getData: () => { data?: T[]; last_page?: number } | null }>,
): Promise<T[]> {
    const first = await fetchFn(1);
    const firstData = first.getData();
    const items: T[] = [...(firstData?.data || [])];
    const lastPage = firstData?.last_page ?? 1;

    if (lastPage > 1) {
        const rest = await Promise.all(
            Array.from({ length: lastPage - 1 }, (_, i) => fetchFn(i + 2))
        );
        for (const res of rest) {
            const d = res.getData();
            if (d?.data) items.push(...d.data);
        }
    }

    return items;
}
